/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { challengeSchema } from '../challenge-schema';

export const listChallengesResponseDataSchema = z.array(challengeSchema);

export type IListChallengesResponseData = z.infer<typeof listChallengesResponseDataSchema>;

export const listChallengesResponseSchema = createApiResponseSchema(
  listChallengesResponseDataSchema,
) as z.ZodSchema<IAPI<IListChallengesResponseData>>;

export type IListChallengesResponse = IAPI<IListChallengesResponseData>;
